import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import { CLEAR_CUSTOMER_REQUIREMENT, FETCH_CUSTOMER_REQUIREMENT } from './crt.actions';
import { CRTFieldValueState } from './crt.types';

const initialState: CRTFieldValueState = {
  items: [],
  loading: false,
  errorMessage: '',
};

export default (
  state: CRTFieldValueState = initialState,
  action: AppAction,
): CRTFieldValueState => {
  switch (action.type) {
    case REQUEST(FETCH_CUSTOMER_REQUIREMENT):
      return { ...state, loading: true };
    case SUCCESS(FETCH_CUSTOMER_REQUIREMENT):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
      };
    case FAILURE(FETCH_CUSTOMER_REQUIREMENT):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case CLEAR_CUSTOMER_REQUIREMENT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
